import Avatar, { type AvatarSizeToken } from '-/Custom/Avatar';
import { useQuery } from 'urql';
import { graphql } from '@/gql/graphql';
import getAvatarText from '@/utils/getAvatarText';

const GetProfileAvatar = graphql(/* GraphQL */ `
  query GetProfileAvatar {
    current_user {
      id
      name
      avatar_id
      color
    }
  }
`);

type ProfileAvatarProps = {
  size?: AvatarSizeToken;
};

function ProfileAvatar({ size = 'sm' }: ProfileAvatarProps) {
  const [{ data }] = useQuery({
    query: GetProfileAvatar,
  });

  const color = data?.current_user?.color;

  return (
    <Avatar
      id={data?.current_user?.avatar_id || ''}
      name={getAvatarText(data?.current_user?.name)}
      color={color}
      size={size}
    />
  );
}

export default ProfileAvatar;
